export type Searchable = {
  title: string
  description?: string
  tags?: string[]
  parentGoalTitle?: string
}

function within1(a: string, b: string): boolean {
  if (a === b) return true
  if (Math.abs(a.length - b.length) > 1) return false
  let i = 0
  let j = 0
  let edits = 0
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) {
      i++
      j++
      continue
    }
    if (++edits > 1) return false
    if (a.length > b.length) i++
    else if (b.length > a.length) j++
    else {
      i++
      j++
    }
  }
  return edits + (a.length - i) + (b.length - j) <= 1
}

const words = (s: string) => s.toLowerCase().match(/[\p{L}\p{N}]+/gu) ?? []

// A query word matches a title word when it's a prefix of it, or (for words of
// 4+ letters) one typo away from it.
function wordHit(q: string, titleWords: string[]): boolean {
  return titleWords.some((w) => w.startsWith(q) || (q.length >= 4 && within1(q, w)))
}

// Relevance of an item for the ⌘K query; 0 = not a match. Titles beat tags beat
// notes beat the parent goal's title; small typos are forgiven.
export function matchScore(item: Searchable, query: string): number {
  const q = query.trim().toLowerCase()
  if (!q) return 0
  if (q.startsWith('#')) {
    const tag = q.slice(1)
    return tag && item.tags?.some((t) => t.toLowerCase().replace(/^#/, '').startsWith(tag)) ? 80 : 0
  }
  const title = item.title.toLowerCase()
  if (title.startsWith(q)) return 110
  if (title.includes(q)) return 100
  const qWords = words(q)
  const tWords = words(item.title)
  if (qWords.length && qWords.every((w) => wordHit(w, tWords))) return 70
  if (item.tags?.some((t) => t.toLowerCase().replace(/^#/, '').startsWith(q))) return 60
  if (item.description?.toLowerCase().includes(q)) return 40
  if (item.parentGoalTitle?.toLowerCase().includes(q)) return 15
  return 0
}
